import AppLayout from "../component/AppLayout";
import React from "react";
import Matches from "../component/page/Matches";
import Heroes from "../component/page/Heroes";
import Players from "../component/page/Players";
import MatchInfo from "../component/page/MatchInfo";
import Patches from "../component/page/Patches";
import HeroInfo from "../component/page/HeroInfo";
import PlayerInfo from "../component/page/PlayerInfo";
import Ladders from "../component/page/Ladders";
import BpSim from "../component/page/BpSim";
import Help from "../component/Help";

const routers = [
    {
        path: "touhou/bpsim",
        element: <BpSim />,
    },
    {
        path: "/",
        element: <AppLayout />,
        children: [
            {
                index: true,
                element: <Matches />,
            },
            {
                path: "matches",
                element: <Matches />,
            },
            {
                path: "heroes",
                element: <Heroes />,
            },
            {
                path: "ladders",
                element: <Ladders />,
            },
            {
                path: "players",
                element: <Players />,
            },
            {
                path: "patches",
                element: <Patches />,
            },
            {
                path: "help",
                element: <Help />,
            },
            {
                path: "match/:id",
                element: <MatchInfo />,
            },
            {
                path: "hero/:id",
                element: <HeroInfo />,
            },
            {
                path: "player/:id",
                element: <PlayerInfo />,
            },
        ],
    },
    {
        path: "bpsim123",
        element: <BpSim />,
    },
]

export default routers
